// extracted by mini-css-extract-plugin
module.exports = {"header":"privacy-agreement_header__5_j6u","box":"privacy-agreement_box__thZ_X","title":"privacy-agreement_title__3IYz0"};